import { useMemo } from 'react';
import { useLocation } from 'react-router';

/**
 * Resolve which language codes apply to the current route: a product page is
 * limited to the product's own languages, every other route follows the site.
 *
 * The codes are passed in rather than read from a store because each venue
 * package owns its own MobX stores; the caller reads them inside `observer`,
 * so tracking is preserved.
 */
export function useSupportedLanguageCodes(
  siteLanguageCodes?: readonly string[],
  productLanguageCodes?: readonly string[]
) {
  const location = useLocation();

  const isProduct = useMemo(
    () => location.pathname.includes('/product/'),
    [location.pathname]
  );

  const supportedLanguageCodes = useMemo(
    () =>
      isProduct ? (productLanguageCodes ?? []) : (siteLanguageCodes ?? []),
    [isProduct, productLanguageCodes, siteLanguageCodes]
  );

  return { isProduct, supportedLanguageCodes };
}
